import { cn } from "@/lib/utils"

/**
 * The Echoes mark, unchanged from v1: a source and the two rings it sends
 * out. Geometry and opacities are the original's; do not redraw it.
 */
export function BrandMark({ className }: { className?: string }) {
  return (
    <svg
      viewBox="0 0 36 36"
      fill="none"
      aria-hidden
      className={cn("size-6 shrink-0", className)}
    >
      <circle cx="18" cy="18" r="4" fill="currentColor" />
      <circle cx="18" cy="18" r="9" stroke="currentColor" strokeWidth="1.5" opacity="0.6" />
      <circle cx="18" cy="18" r="14" stroke="currentColor" strokeWidth="1.5" opacity="0.3" />
    </svg>
  )
}

/**
 * The full logo as v1 set it at its small size: the mark beside the name in
 * Instrument Serif. The serif belongs to the logo and to public pages; the
 * app's own interface stays in Geist.
 */
export function Wordmark({ className }: { className?: string }) {
  return (
    <span className={cn("inline-flex items-center gap-3", className)}>
      <BrandMark />
      <span className="font-serif text-lg leading-none tracking-tight">Echoes</span>
    </span>
  )
}
